export default __webpack_public_path__ + "static/media/angryrhymetown.ee9d9bf9.png";